export default __webpack_public_path__ + "static/media/referral-trophy.0d65fdaf.svg";